<template>
  <div class="debt-report">
    <el-card class="box-card" v-loading="loading">
      <div slot="header" class="clearfix">
        <span><i class="el-icon-date"></i> Debt Report</span>
      </div>


          <el-tabs type="border-card" v-model="debtNameTap">
            <el-tab-pane label="Out Standing" name="outstanding">
              <div class="export-area">
                <el-button v-if="Object.keys(outstandingList).length > 0" icon="el-icon-download" type="success" @click="Report('outstanding')">Export</el-button>
              </div>
              <el-tabs type="card" v-model="debtCurrencyOutstandingTap">
                <el-tab-pane v-for="currency in Object.keys(outstandingSum)" :key="currency" :label="`${currency.toUpperCase()} ${outstandingSum[currency].amountFormat}`" :name="currency">
                  <data-tables
          
                    :data="outstandingList[currency]" 
                    border 
                    :page-size="20"
                    :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
                    <el-table-column prop="member_code" label="Member Code" header-align="center" align="center"> </el-table-column>
                    <el-table-column prop="bankholderId" label="BankholderID" header-align="center" align="center"> </el-table-column>
                    <el-table-column prop="activeDebt" label="Active Debt" header-align="center" align="center"> </el-table-column>
                    <el-table-column prop="totalDebt" label="Total Debt" header-align="center" align="center"> </el-table-column>
                    <el-table-column prop="bankholderId" label="Action" header-align="center" align="center">
                      <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="showDetail(scope.row.bankholderId)">View</el-button>
                      </template>
                    </el-table-column>
        
                  </data-tables>
                </el-tab-pane>
              </el-tabs>

            </el-tab-pane>
            <el-tab-pane label="Loss" name="loss">
              <div class="export-area">
                <el-button v-if="Object.keys(lossList).length > 0" icon="el-icon-download" type="success" @click="Report('loss')">Export</el-button>
              </div>
              <el-tabs type="card" v-model="debtCurrencyLossTap">
                <el-tab-pane v-for="currency in Object.keys(lossSum)" :key="currency" :label="`${currency.toUpperCase()} ${lossSum[currency].amountFormat}`" :name="currency">
                  <data-tables
          
                    :data="lossList[currency]" 
                    border 
                    :page-size="20"
                    :pagination-props="{ background: true, pageSizes: [20, 50, 100, 200] }">
                    <el-table-column prop="member_code" label="Member Code" header-align="center" align="center"> </el-table-column>
                    <el-table-column prop="bankholderId" label="BankholderID" header-align="center" align="center"> </el-table-column>
                    <el-table-column prop="activeDebt" label="Active Debt" header-align="center" align="center"> </el-table-column>
                    <el-table-column prop="totalDebt" label="Total Debt" header-align="center" align="center"> </el-table-column>
                    <el-table-column prop="bankholderId" label="Action" header-align="center" align="center">
                      <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="showDetail(scope.row.bankholderId)">Pay</el-button>
                        <el-button size="mini" type="primary" @click="showDetail(scope.row.bankholderId)">View</el-button>
                      </template>
                    </el-table-column>
        
                  </data-tables>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </el-tabs>
    </el-card>

  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { getDebtProject, getDebtProjectSummary, getDebtProjectExport } from '@/api/debt'
export default {
  props: {
    project: String
  },
  watch: {
      project(val, old) {
        this.project_uid = val;
        this.queryInit()
      }
  },

  computed:{
     ...mapGetters([
      "user_project"
    ]),
    project_uid(){
      return this.project || this.user_project
    },
    device() {
      return this.$store.state.app.device;
    }
  },
  data(){
    return {
      debtNameTap: "outstanding",
      debtCurrencyOutstandingTap: "",
      debtCurrencyLossTap: "",
      outstandingList: {},
      lossList: {},
      outstandingSum: {},
      lossSum: {},
      loading: false,
      onlyactivedebt: true
    }
  },
  methods:{
    getList(){
      this.loading = true
      getDebtProject(this.project_uid, this.onlyactivedebt, 'outstanding').then(({result, data})=>{
        if(result){
          this.outstandingList = data
          
        }
      })

      getDebtProject(this.project_uid, this.onlyactivedebt, 'loss').then(({result, data})=>{
        if(result){
          this.lossList = data
          
        }
      })
      
    },

    getSum(){

      getDebtProjectSummary(this.project_uid, 'outstanding').then(({result, data})=>{
        if(result){
          this.outstandingSum = data ? data : {}
          this.debtCurrencyOutstandingTap = Object.keys(this.outstandingSum)[0] || "";
        }
      })

      getDebtProjectSummary(this.project_uid, 'loss').then(({result, data})=>{
        this.loading = false
        if(result){
          this.lossSum = data ? data : {}
          this.debtCurrencyLossTap = Object.keys(this.lossSum)[0] || "";
        }
      })

    },
    showDetail(bankholderId){
      window.open(`/bank-account/view/customer/${bankholderId}?tab=debt`, '_blank');
    },

    Report(type){
      getDebtProjectExport(this.project_uid, this.onlyactivedebt, type)
    },

    queryInit(){
      
      this.getList()
      this.getSum()
      
    }

  },
  created(){
    this.queryInit()
   
  }
}
</script>

<style lang="scss">
.debt-report{
  .export-area{
    text-align: right;
    z-index: 1;
  }

  code {
    color: #408fff;
    background-color: #e6effb;
    margin: 0 4px;
    display: inline-block;
    padding: 1px 5px;
    font-size: 14px;
    border-radius: 3px;
    height: 18px;
    line-height: 18px;
  }

  pre{
    white-space: pre-line;
    line-height: 30px;
  }
}
</style>